const state = {
  view: {
    drawer: true,
    dialog: false,
    loading: false
  },
}

const mutations = {
  setViewDrawer(state, drawer) {
    state.view.drawer = drawer;
  },
  setViewDialog(state, dialog) {
    state.view.dialog = dialog
  },
  setAppLoading() {
    // console.log('setting state app is loading')
    state.view.loading = true;
  },
  setAppDoneLoading() {
    // console.log('setting state app stopped loading')
    state.view.loading = false;
  }
}

const actions = {
  toggleDrawer({ commit, state }) {
    commit('setViewDrawer', !state.view.drawer);
  },
  hideDrawer({ commit }) {
    commit('setViewDrawer', false);
  },
  showDrawer({ commit }) {
    commit('setViewDrawer', true);
  },
  showDialog({ commit }){
    commit('setViewDialog', true)
  },
  hideDialog({ commit }){
    commit('setViewDialog', false)
  },
  appLoading({ commit }){
    commit('setAppLoading');
  },
  stopAppLoading({commit}){
    commit('setAppDoneLoading');
  }
}

const getters = {
	navState: (state) => {
		return state.view;
  },
  isAppLoading: (state) => {
    return state.view.loading;
  }
}

export default {
	state,
	mutations,
  actions,
  getters
}

